import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { images } from '../data/images';
export function Instructor() {
  const {
    t
  } = useLanguage();
  const i = t.instructor;
  return <section id="about" aria-labelledby="about-title" className="scroll-mt-20 bg-stone py-24 md:py-32" data-id="element-192" data-mp="2vaotqmbonsmz">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 md:px-10 lg:grid-cols-12 lg:gap-20" data-id="element-193" data-mp="305uf9k16b5aj">
        <figure className="lg:col-span-5" data-id="element-194" data-mp="3nyavdp1con77">
          <div className="overflow-hidden rounded-[28px] bg-mist" data-id="element-195" data-mp="3sx5q9pcle27o">
            <img src={images.instructor} alt={i.imageAlt} loading="lazy" className="aspect-[4/5] w-full object-cover object-[45%_50%]" data-id="element-196" data-mp="3su9sc10qvdj8" />
          </div>
        </figure>

        <div className="lg:col-span-7 lg:pt-6" data-id="element-197" data-mp="22jom81e586qk">
          <h2 id="about-title" className="text-[14px] font-semibold text-violet" data-id="element-198" data-mp="22ivht72nptbl">
            {i.title}
          </h2>
          <p className="mt-3 flex flex-wrap items-baseline gap-x-4 gap-y-1" data-id="element-199" data-mp="27gx03ps9dom0">
            <span className="font-display text-[44px] font-medium leading-none tracking-[-0.02em] text-ink md:text-[56px]" data-id="element-200" data-mp="2huadurc8o4y9">
              {i.name}
            </span>
            <span className="font-display text-[18px] font-medium text-muted md:text-[20px]" data-id="element-201" data-mp="2qvrpnxim5kh5">
              — {i.role}
            </span>
          </p>

          <p className="mt-10 font-serif text-[24px] italic leading-[1.4] text-ink md:text-[28px]" data-id="element-202" data-mp="2lxylfa0vf0ji">
            {i.motto}
          </p>
          <p className="mt-6 max-w-2xl text-[17px] text-muted" data-id="element-203" data-mp="2vul4pudjtjjf">{i.bio}</p>
          <p className="mt-6 border-l-2 border-violet pl-5 font-serif text-[20px] text-ink" data-id="element-204" data-mp="39l6nzk6wzvhu">
            {i.closing}
          </p>

          <div className="mt-12 border-t border-line pt-8" data-id="element-205" data-mp="35knvrp140nf4">
            <h3 className="font-display text-[16px] font-semibold text-ink" data-id="element-206" data-mp="3jjdv7bbeiz6n">{i.credentialsTitle}</h3>
            <ul className="mt-5 grid gap-x-10 gap-y-3 sm:grid-cols-2" data-id="element-207" data-mp="3ekb1uo4sahei">
              {i.credentials.map(c => <li key={c} className="flex items-start gap-3 text-[15.5px] leading-[1.6] text-charcoal" data-id="element-208" data-mp="2c7erpfa39lif">
                  <CheckIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-violet" data-id="element-209" data-mp="2g7oxaqtyy9wr" />
                  {c}
                </li>)}
            </ul>
          </div>

          <a href="#contact" className="btn btn-outline mt-12" data-id="element-210" data-mp="2py03yl51ex7c">
            {i.cta}
          </a>
        </div>
      </div>
    </section>;
}